import React, { useEffect, useState } from "react";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import useNear from "../hooks/nearHook";
import useSbt from "../hooks/sbtHook";
import useTokenRouting from "../hooks/tokenRoutingHook";
import Button from "@mui/material/Button";
import SbtMetadataTable from "../components/SbtMetadataTable";
import SbtSelector from "../components/SbtSelector";
import SbtTokenListTable from "../components/SbtTokenListTable";
import AccountField from "../components/AccountField";

const SbtConsentDashboard = ({}) => {
  const near = useNear();
  const sbt = useSbt();

  const [sbtMetadata, setSbtMetadata] = useState({});
  const [sbtTokens, setSbtTokens] = useState([]);
  const { contractId, accountId, setContractId, setAccountId } =
    useTokenRouting();
  const [selectedTokens, setSelectedTokens] = useState([]);

  useEffect(() => {
    if (!near.account.account) {
      return;
    }
    if (!contractId) {
      setSbtMetadata({});
    }
    sbt.getContractMetadata(contractId).then((result) => {
      setSbtMetadata(result || {});
      if (!result) {
        setSelectedTokens([]);
      }
    });
  }, [contractId, near.account.account]);

  useEffect(() => {
    setAccountId(near.account.account)
  }, [accountId, near.account.account])

  useEffect(() => {
    if (!contractId || !accountId || !near.account.account) {
      setSbtTokens([])
      return;
    }
    sbt.getSbtTokensForAccount(contractId, accountId).then((result) => {
      setSbtTokens(result);

      setSelectedTokens([]);
    });
  }, [contractId, accountId, near.account.account]);

  const addConsent = () => {
    if(!contractId || !selectedTokens?.length){
      return
    }
    sbt.addConsent(contractId, selectedTokens)
  }

  return (
    <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
      <Grid container spacing={3}>
        <Grid item xs={12} md={5}>
          <Paper
            sx={{
              p: 2,
              display: "flex",
              flexDirection: "column",
              height: 420,
            }}
          >
            <SbtSelector
              sbtContractId={contractId}
              setSbtContractId={setContractId}
            />
            <SbtMetadataTable sbtMetadata={sbtMetadata} />
          </Paper>
        </Grid>
        <Grid item xs={12} md={7}>
          <Paper
            sx={{
              p: 2,
              display: "flex",
              flexDirection: "column",
              height: 420,
            }}
          >
            <AccountField accountId={accountId} setAccountId={setAccountId} disabled />
            <SbtTokenListTable
              sbtTokens={sbtTokens}
              onSelect={(tokenId) => {
                if (selectedTokens.includes(tokenId)) {
                  setSelectedTokens(
                    selectedTokens.filter((_t) => _t !== tokenId)
                  );
                } else {
                  setSelectedTokens([...selectedTokens, tokenId]);
                }
              }}
              selectedTokens={selectedTokens}
              showConsent
            />
          </Paper>
        </Grid>
        <Grid item xs={12} md={5}>
          <Paper
            sx={{
              p: 2,
              display: "flex",
              flexDirection: "column",
              height: 100,
            }}
          >
            <Button variant="contained" disabled={!selectedTokens.length} onClick={addConsent}>
              Consent to ({selectedTokens.length}) tokens
            </Button>
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
};

export default SbtConsentDashboard;
